import { useContext } from "react";
import get from "lodash.get";
import type { DatasourceProps } from "types/datasource";
import type { ServerSideStoryblokPages } from "types/storyblok";
import type { PageName } from "utils/getPageUrl/types";
import { DataContext } from "./DataContext";
import type { TrustpilotReview, TrustpilotBusinessUnit, ReferralProgramConfig, CMSLanguagesData } from "./hooks.d";

export const useReviews = () => get(useContext(DataContext), "reviews", []) as TrustpilotReview[];

export const useTrustpilotInfo = () => get(useContext(DataContext), "trustpilotInfo", {}) as TrustpilotBusinessUnit;

export const useReferralProgramConfig = () =>
  get(useContext(DataContext), "referralProgramConfig", {}) as ReferralProgramConfig;

export const usePageName = () => get(useContext(DataContext), "pageName", "") as PageName;

export const useCMSLanguageData = () => get(useContext(DataContext), "cmsLanguagesData", []) as CMSLanguagesData[];

export const useServerSideStoryblokPages = () =>
  get(useContext(DataContext), "serverSideStoryblokPages", {}) as ServerSideStoryblokPages;

export const useGoogleOptimizeExperimentId = (experimentName: string) => {
  const experimentIds = get(useContext(DataContext), "googleOptimizeExperimentIds", []) as DatasourceProps[];
  const selectedExperiment = experimentIds.find((experiment) => experiment.name === experimentName);

  if (!selectedExperiment) return null;
  const { value, dimension_value: dimensionValue } = selectedExperiment;

  return dimensionValue ?? value;
};
